const postRoleAvailabilityPayload = (payload) => {
  return {
    name: payload.name,
  };
};

export default postRoleAvailabilityPayload;
